import {ProcessorFieldOpKey} from './ProcessorFieldOpKey';

export class ProcessorOperation {
code: string;
inFields: ProcessorFieldOpKey[];
operation: string;
order: number | null;
orderedChildren: ProcessorOperation[];
outFields: ProcessorFieldOpKey[];
parentCode: string;
}

